module.exports = __webpack_public_path__ + "static/media/icon_info_active.577e2b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_info_active.png
// module id = 236
// module chunks = 0